// extracted by mini-css-extract-plugin
module.exports = {"container":"e_wC","label":"e_xC","image":"e_yC","name":"e_zC","description":"e_AC","descriptionCollapsed":"e_BC","bottomLine":"e_CC","socialIcon":"e_DC"};